import { Typography } from '@mui/material';

import ChartBoxMultipleOutline from '@/assets/icons/ChartBoxMultipleOutline';
import AccordionSection from '@/features/DataHub/components/AccordionSection';
import BasicUserPreview from '@/features/DataHub/components/Preview/BasicUserPreview';
import useUserDetails from '@/hooks/useUserDetails';

import Preview from '../Preview';

const PreviewAccordion = () => {
  const { isUserBasic, isUserExpired } = useUserDetails();

  return (
    <AccordionSection
      icon={<ChartBoxMultipleOutline />}
      title='Chart view'
    >
      <Typography
        sx={{
          fontSize: '12px',
          color: 'text.disabled',
          mb: '16px'
        }}
      >
        Chart displays up to 6 items
      </Typography>
      {isUserBasic || isUserExpired ? <BasicUserPreview /> : <Preview showLegend />}
    </AccordionSection>
  );
};

export default PreviewAccordion;
